<nb-card class="session-modal">
  <nb-card-header class="session-modal__header">
    <nb-icon
      class="close cursor-pointer"
      icon="close-outline"
      (click)="cancel()"
    ></nb-icon>
  </nb-card-header>
  <nb-card-body>
    <div class="session-modal__icon-wrapper">
      <div class="session-modal__icon">
        <nb-icon icon="log-out-outline"> </nb-icon>
      </div>
    </div>

    <div class="session-modal__text">
      <h3>Session ended</h3>

      <p>
        Your session has been ended because your account was signed in
        elsewhere.
      </p>

      <span> Please sign in again to continue. </span>
    </div>

    <button nbButton status="primary" size="large" fullWidth (click)="signIn()">
      <nb-icon icon="log-in-outline"> </nb-icon>

      Sign in again
    </button>
  </nb-card-body>
</nb-card>
